import React, { useEffect, useRef, useState } from "react";

const NAV_ITEMS = [
  { key: "today", label: "Today" },
  { key: "plan", label: "Plan" },
  { key: "ncrs", label: "NCRs" },
  { key: "weekly", label: "Weekly report" },
];

const NAV_COUNT_KEY = { today: "today", ncrs: "ncrs", weekly: "reports" };

/**
 * Top bar per mockups/cockpit-v3/Main.dc.html: project pill with a
 * per-project client-side filter, Today/Plan/NCRs/Weekly report nav with
 * counts, avatar initials.
 */
export default function TopBar({ screen, onNavigate, projectCodes, selectedCodes, onSelectCodes, navCounts, weekLabel, identity }) {
  const [pillOpen, setPillOpen] = useState(false);
  const wrapRef = useRef(null);
  const pillRef = useRef(null);

  // Owner retest 3: the selector stayed open until toggled again. Close on a
  // click outside it and on Escape (focus returns to the toggle on Escape).
  useEffect(() => {
    if (!pillOpen) return undefined;
    function onDown(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setPillOpen(false);
    }
    function onKey(e) {
      if (e.key === "Escape") {
        setPillOpen(false);
        if (pillRef.current) pillRef.current.focus();
      }
    }
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [pillOpen]);
  const allSelected = selectedCodes.length === 0 || selectedCodes.length === projectCodes.length;
  const pillText = allSelected
    ? `All projects · ${projectCodes.join(", ")}`
    : `${selectedCodes.length} project${selectedCodes.length === 1 ? "" : "s"} · ${selectedCodes.join(", ")}`;

  function toggleCode(code) {
    if (selectedCodes.includes(code)) onSelectCodes(selectedCodes.filter((c) => c !== code));
    else onSelectCodes([...selectedCodes, code]);
  }

  return (
    <div className="top">
      <div ref={wrapRef} style={{ display: "flex", alignItems: "center", gap: 10, position: "relative" }}>
        <div className="mono" style={{ fontSize: 15, fontWeight: 600, color: "var(--t1)" }}>NEG</div>
        <div
          className="pill"
          ref={pillRef}
          role="button"
          tabIndex={0}
          aria-haspopup="true"
          aria-expanded={pillOpen}
          onClick={() => setPillOpen((v) => !v)}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setPillOpen((v) => !v); } }}
        >
          <div className="mono" style={{ fontSize: 11, fontWeight: 500, color: "var(--t2)" }}>{pillText}</div>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
        {pillOpen ? (
          <div className="card" style={{ position: "absolute", top: 40, left: 44, zIndex: 10, minWidth: 160 }}>
            {projectCodes.map((code) => (
              <label key={code} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, color: "var(--t1)" }}>
                <input
                  type="checkbox"
                  checked={allSelected || selectedCodes.includes(code)}
                  onChange={() => toggleCode(code)}
                />
                <span className="mono">{code}</span>
              </label>
            ))}
          </div>
        ) : null}
        <div style={{ fontSize: 11, color: "var(--t3)", paddingLeft: 4 }}>{identity.role}</div>
      </div>
      <div className="top-nav" style={{ display: "flex", alignItems: "center", gap: 2 }}>
        {NAV_ITEMS.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`nav ${screen === item.key ? "on" : ""}`}
            data-testid={`nav-${item.key}`}
            onClick={() => onNavigate(item.key)}
          >
            {item.label}
            {navCounts[NAV_COUNT_KEY[item.key]] ? <span className="n">{navCounts[NAV_COUNT_KEY[item.key]]}</span> : null}
          </button>
        ))}
      </div>
      <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 12 }}>
        <div className="mono" style={{ fontSize: 11, color: "var(--t3)" }}>{weekLabel}</div>
        <div className="avatar">{identity.initials}</div>
      </div>
    </div>
  );
}
